import { AreaInput } from 'src/graphql';
import { TDateRangeFieldWithValue } from 'src/utils/assetsFields/assetsFields.types';
import { TLocationSearchValue } from 'src/components/LocationSearch';

export type TOnChangePayload<TValue, TName> = { value: TValue; name: TName };

type TLat = number;
type TLng = number;

export type TLngLat = {
  lng: TLng;
  lat: TLat;
};

export type TLngLatArray = [TLng, TLat];

export type TAssetType =
  | 'Area'
  | 'FiniteDieselGenerator'
  | 'Load'
  | 'PV'
  | 'Storage'
  | 'MarketMaker'
  | 'InfiniteBus';

// These are all LibrariesTags supported by the backend.
export type TLibrariesTags =
  | 'Load'
  | 'Public'
  | 'Storage'
  | 'PV'
  | 'FiniteDieselGenerator'
  | 'CommercialProducer'
  | 'Area'
  | 'MarketMaker'
  | 'InfiniteBus'
  | 'DefaultLib'
  | 'Home';

export enum EFormVariant {
  Express = 'FORM_EXPRESS',
  Advanced = 'FORM_ADVANCED',
  KpiSettings = 'FORM_KPI_SETTINGS',
}

export type TFileIdentifiers = Pick<File, 'lastModified' | 'name'>;

export type TUploadedProfile = string | TFileIdentifiers;

export type TFieldValue =
  | string
  | boolean
  | number
  | undefined
  | null
  | TLocationSearchValue['coords']
  | TUploadedProfile
  | TDateRangeFieldWithValue['value'];

export type TFieldUnits =
  | 'kVA'
  | 'kWh'
  | 'cents / kWh'
  | 'kW'
  | 'W'
  | 'cents / kWh per update'
  | 'sec'
  | 'min'
  | '%';

export enum EUserRoles {
  Admin = 'Admin',
  Researcher = 'Researcher',
  DSO = 'DSO',
  ExchangeOperator = 'Exchange Operator',
}

// TODO: Backend implemented enum SimulationStatusType, let's use it 🎉
export type TSimResultsStatus =
  | 'loading'
  | 'queued'
  | 'initializing'
  | 'started'
  | 'running'
  | 'paused'
  | 'stopped'
  | 'stopping'
  | 'finished'
  | 'error'
  | 'failed'
  | 'timed-out';

export type TLiveEvent = {
  type: 'delete_area' | 'update_area' | 'create_area';
  description: string;
  representation: AreaInput;
};

// ConfigType is defined in the file: src/graphql/index.tsx
// GridFeeType is defined in the file: src/graphql/index.tsx
